<template>
  <div id="contenedor-agregar-documento-proyecto">
    <v-form v-model="formularioValido" ref="formAgregarProyectoDocumento">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar documento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <CustomAutocomplete
              v-model="documento.idProyectoDocumentoTipo"
              cols="12"
              label="Tipo Documento"
              :items="listadoTiposDocumentos"
              item-text="descripcion"
              item-value="id"
              clearable
              :rules="[mixReglas.requerido]"
            >
            </CustomAutocomplete>
            <CustomTextField
              v-model="documento.descripcion"
              cols="12"
              label="Descripción"
              :rules="[mixReglas.requerido]"
            >
            </CustomTextField>
            <CustomDatePicker v-model="documento.fecha" label="Fecha"> </CustomDatePicker>
            <v-row align="center" justify="center">
              <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                <v-icon center>
                  mdi-paperclip
                </v-icon>
              </v-btn>
              <template v-if="nombreArchivoSeleccionado">
                <span>{{ nombreArchivoSeleccionado }}</span>
              </template>
              <template v-else>
                <span> Seleccionar Archivo </span>
              </template>
            </v-row>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            class="mr-3"
            tipo="formCancelar"
            label="Cancelar"
            @click="cerrar">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            @click="guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
        <v-file-input
        v-show="false"
        show-size
        type="file"
        ref="anexoDocumento"
        name="anexo"
        id="anexo"
        @change="seleccion"
        :rules="[mixReglas.requerido]"
      >
      </v-file-input>
    </v-form>
  </div>
</template>

<script>
import PROYECTOS_DOCUMENTOS_TIPOS from '@/graphql/querys/administracion/control-proyectos/documentos-tipos/proyectosDocumentosTipos.gql';
import mixProyectosDocumentos from './mixProyectosDocumentos';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

export default {
  name: 'AgregarDocumentoProyecto',
  mixins: [mixProyectosDocumentos, mixSubirArchivo],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomAutocomplete,
    CustomTextField,
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      contador: 0,
      nombreArchivoSeleccionado: null,
      formularioValido: false,
      enviandoFormulario: false,
      documentos: [],
      documento: {
        idProyecto: this.idProyecto,
        idProyectoDocumentoTipo: null,
        fecha: null,
        descripcion: null,
        fileData: null,
      },
    };
  },
  apollo: {
    proyectosDocumentosTipos: {
      query: PROYECTOS_DOCUMENTOS_TIPOS,
    },
  },
  methods: {
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      const archivo = await this.mixSubirArchivo(datosArchivo);
      if (archivo.status === 'ok') {
        this.documento.fileData = JSON.stringify(archivo.data);
        this.documentos.push(this.documento);
        this.mixAgregarProyectoDocumento();
      }
    },
    setDatosArchivo() {
      const datos = {
        nombre: `${this.nombreArchivoSeleccionado}`,
        path: 'Proyectos/Documentos',
      };
      return datos;
    },
    cerrar() {
      this.documentos = [];
      this.$refs.formAgregarProyectoDocumento.reset();
      this.$emit('cerrar');
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    seleccion() {
      this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0]?.name;
    },
  },
  computed: {
    listadoTiposDocumentos() {
      if (!this.proyectosDocumentosTipos) return [];
      return this.proyectosDocumentosTipos;
    },
  },
};
</script>

<style lang="scss"></style>
